import { render, staticRenderFns } from "./newpushbuttonalert.vue?vue&type=template&id=17b6c6d1&scoped=true"
import script from "./newpushbuttonalert.vue?vue&type=script&lang=js"
export * from "./newpushbuttonalert.vue?vue&type=script&lang=js"
import style0 from "./newpushbuttonalert.vue?vue&type=style&index=0&id=17b6c6d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b6c6d1",
  null
  
)

export default component.exports